import {useWholesaler} from 'context/wholesaler';
import {toast} from 'react-toastify';
import SimpleForm from './simple';
import AuctionForm from './auction';
import SaleForm from './sale';

const OwnerForm = () => {
  const {wholesaler} = useWholesaler();
  switch (wholesaler?.type) {
    case 'simple':
      return <SimpleForm />;
    case 'auction':
      return <AuctionForm />;
    case 'sale':
      return <SaleForm />;
    default:
      toast.error('لطفا نوع آگهی را انتخاب کنید');
      return <></>;
  }
};

export default OwnerForm;
